import React from 'react';
import { getPageConfig, setPageConfig } from '@utils';
import {
  PAGE_KEYS,
  THEME_VARIANT,
  LAYOUT,
  BluePantherTheme,
} from '@shared/constants';
const noop = () => {};
export const AppContext = React.createContext({
  appRatingData: {
    isOpen: false,
    showOnPackageSubmit: false,
    isOpenedFromPackage: false,
  },
  headerElements: [],
  setAppRatingData: noop,
  selectedLayout: LAYOUT.SIDEBAR_HEADER,
  selectedTheme: BluePantherTheme,
  selectedThemeVariant: THEME_VARIANT.LIGHT,
  setSelectedThemeVariant: noop,
  setHeaderElements: noop,
  setSidebarElements: noop,
});

export const AppContextProvider = ({ children }) => {
  const setAppRatingData = rating => {
    setAppState(prevState => ({
      ...prevState,
      conductorRating: {
        ...prevState.conductorRating,
        isOpen: rating.isOpen || false,
        showOnPackageSubmit: rating.showOnPackageSubmit || false,
        isOpenedFromPackage: rating.isOpenedFromPackage || false,
      },
    }));
  };

  const setHeaderElements = (headerElements = []) => {
    setAppState(prevState => ({
      ...prevState,
      headerElements,
    }));
  };

  const setSelectedThemeVariant = selectedThemeVariant => {
    setAppState(prevState => ({
      ...prevState,
      selectedThemeVariant,
    }));

    setPageConfig(PAGE_KEYS.GLOBAL, {
      theme: selectedThemeVariant,
    });
  };

  const setSelectedLayout = selectedLayout => {
    setAppState(prevState => ({
      ...prevState,
      selectedLayout,
    }));
  };

  const setSelectedTheme = selectedTheme => {
    setAppState(prevState => ({
      ...prevState,
      selectedTheme,
    }));
  };

  const setSidebarElements = (sidebarElements = []) => {
    setAppState(prevState => ({
      ...prevState,
      sidebarElements,
    }));
  };

  const defaultTheme =
    (getPageConfig(PAGE_KEYS.GLOBAL) || {}).theme || THEME_VARIANT.LIGHT;

  const initialAppState = {
    headerElements: [],
    setHeaderElements,
    sidebarElements: [],
    setSidebarElements,
    selectedThemeVariant: defaultTheme,
    selectedTheme: BluePantherTheme,
    selectedLayout: LAYOUT.BAR,
    setSelectedTheme,
    setSelectedLayout,
    setSelectedThemeVariant,
    currentWorkspace: {
      uid: null,
      name: null,
    },
    appRatingData: {
      isOpen: false,
      showOnPackageSubmit: false,
      isOpenedFromPackage: false,
    },
    setAppRatingData,
  };

  const [appState, setAppState] = React.useState(initialAppState);

  return <AppContext.Provider value={appState}>{children}</AppContext.Provider>;
};

export const AppContextConsumer = AppContext.Consumer;
